<template>
  <div>
    <span
      v-if="status === 'Completed'"
      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 capitalize"
    >
      Complete
    </span>
    <span
      v-else-if="status === 'Processing'"
      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 capitalize"
    >
      Processing
    </span>
    <span
      v-else
      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 capitalize"
    >
      Pending
    </span>
  </div>
</template>

<script>
export default {
  name: 'StatusText',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
};
</script>
